import React, { useEffect, useState, useContext } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
//Context
import UserContext from "../../context/UserContext";
//Api 
import { AuthFetchAPI } from '../../api/Auth';
import { UsersFetchAPI } from '../../api/Users';
import { BusinessFetchAPI } from '../../api/Business';
//Utils 
import ValidDomain from '../utils/ValidDomain';
import { toast } from "../../utils/toast/toast";
//Components 
import Swal from "sweetalert2";
//Img
import logo_sp from '../../assets/img/logos/icon-black.png';
//CSS
import "./login.css";
import Particles from '../../utils/Particles/Particles';
import { getCurrentSessionState } from '../../utils/AndroidSessionBridge';

/* ---------- Íconos inline ---------- */
const IconStore = (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M3 9 4 4h16l1 5" /><path d="M4 9v11h16V9" /><path d="M3 9h18" /><path d="M9 20v-6h6v6" />
    </svg>
);
const IconDashboard = (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <rect x="3" y="3" width="7" height="9" rx="1.5" /><rect x="14" y="3" width="7" height="5" rx="1.5" />
        <rect x="14" y="12" width="7" height="9" rx="1.5" /><rect x="3" y="16" width="7" height="5" rx="1.5" />
    </svg>
);
const IconLock = (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <rect x="4" y="11" width="16" height="9" rx="2" /><path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </svg>
);
const IconEye = (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" /><circle cx="12" cy="12" r="3" />
    </svg>
);
const IconEyeOff = (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M9.9 5.1A10.4 10.4 0 0 1 12 5c6.5 0 10 7 10 7a18.6 18.6 0 0 1-3.2 4.1M6.3 6.3A18.4 18.4 0 0 0 2 12s3.5 7 10 7a10.3 10.3 0 0 0 4.3-.9" /><path d="m3 3 18 18" />
    </svg>
);
const IconCheck = (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="m5 12 5 5L20 7" />
    </svg>
);
const IconArrow = (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M5 12h14" /><path d="m13 6 6 6-6 6" />
    </svg>
);
const IconBolt = (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
        <path d="M13 2 3 14h7l-1 8 10-12h-7l1-8Z" />
    </svg>
);
/* Helper solo de presentación (iniciales para el avatar) */
const getInitials = (name = "") => {
    const parts = String(name).trim().split(/\s+/).filter((p) => /[A-Za-zÀ-ÿ]/.test(p));
    if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
    return (parts[0] || String(name)).slice(0, 2).toUpperCase();
};

const Login = () => {
    //States 
    const [businessData, setBusinessData] = useState({
        name: '',
        id: 0
    });
    const [selectedBranch, setSelectedBranch] = useState();
    const [users, setUsers] = useState([]);
    const [businessCode, setBusinessCode] = useState(() => {
        if (localStorage.getItem("business") != "" && localStorage.getItem("business") != undefined) {
            return JSON.parse(localStorage.getItem("business")).code
        }
    });
    const [branchofficeCode, setBranchofficeCode] = useState(() => {
        if (localStorage.getItem("branchoffice") != "" && localStorage.getItem("branchoffice") != undefined) {
            return JSON.parse(localStorage.getItem("branchoffice")).code
        }
    });
    const [publicToken, setPublicToken] = useState();
    //Context 
    const { setUserData } = useContext(UserContext);
    //Params
    const { business_code, branchoffice_code } = useParams();
    //Navigation
    const navigate = useNavigate();
    //Location page 
    const url_path = useLocation();

    useEffect(() => {
        const sessionState = getCurrentSessionState();

        if (sessionState.has_session && sessionState.business_code) {
            setUserData({ token: sessionState.token, user: sessionState.user });
            navigate(`/overview/${sessionState.business_code}`);
        }
    }, []);

    //Function to get the initial data
    const getInitialData = async (business_code) => {
        //Variables
        let response_business = '';
        try {
            //We get the business
            response_business = await BusinessFetchAPI.getBusinessByCode(business_code)
            //We set the business data
            localStorage.setItem('logoBusiness', response_business.data.businessConfig.logo);
            setBusinessData(response_business.data.business)
        } catch (err) {
            //If we get some error we redirect to a no mactch page
            navigate('/nomatch')
            return null;
        }

        //We gen a public token scoped to THIS business (response_business.data.business.id)
        const publicTokenResponse = await AuthFetchAPI.generatePublicToken(response_business.data.business.id);
        //Set public token
        setPublicToken(publicTokenResponse.data.token);

        //We return the fresh token so callers use the one that matches this business,
        //instead of falling back to a stale token/cookie left over from another company
        return publicTokenResponse.data.token;
    }

    //Function to get the users of a branchoffice or a business depending the role.
    //Must only be called AFTER getInitialData has resolved, so the public-token cookie
    //the backend just set for THIS business is the one sent with the request.
    const getUsers = async (public_token) => {
        try {
            //Variables
            let response = await UsersFetchAPI.getUsersByPermissionAccess("dashboard_login", public_token || publicToken);
            setUsers(response.data.users);
        } catch (err) {
            //If we get some error we set the users data empty
            setUsers([])
            setSelectedBranch(null)
        }
    }

    //Event to login
    const submit = async (e) => {
        e.preventDefault();
        localStorage.setItem('x-access-token', "");
        localStorage.removeItem('user');
        localStorage.removeItem('branchoffice_selected');
        localStorage.removeItem('branchoffice');
        //We check if the user check one branch office 
        if ((url_path.pathname.includes('cashier') && selectedBranch !== null) || (url_path.pathname.includes('dispatcher') && selectedBranch !== null) || (!url_path.pathname.includes('dispatcher') || !url_path.pathname.includes('cashier') && selectedBranch === undefined || selectedBranch === null)) {
            const form = new FormData(e.target);
            let user_logged = Object.fromEntries(form.entries());
            user_logged.business_id = businessData.id;
            try {
                const response = await AuthFetchAPI.login(user_logged);
                //We get the token and user data 
                let token = response.data.token;
                let user = response.data.user;
                //We set the user info and the token access 
                localStorage.setItem('user', JSON.stringify(user));
                localStorage.setItem('x-access-token', token);
                localStorage.setItem('branchoffice', "");
                //We set the context of the user 
                setUserData({ token, user: user });

                //We check the role of the user and depending of it we redirect 
                if (user.role.find(element => element.role_id === 7 || element.role_id === 3 || element.role_id === 6 || element.role_id === 11 || element.role_id === 12 || element.role_id >= 14) !== undefined) {
                    navigate(`/transactions/${businessCode}`)
                } else if (user.role.find(element => element.role_id === 8 || element.role_id === 13) !== undefined) {
                    navigate(`/products/${businessCode}`)
                }

            } catch (err) {
                // Swal.fire({
                //     icon: "error",
                //     title: err.response.data.error+"Que zopa",
                //     showConfirmButton: false,
                //     timer: 1500,
                // });
                // err.response?.data?.error ||

                toast.detailed({
                    type: "error",
                    title: "No se pudo iniciar sesión, usuario o contraseña incorrecta",
                    details: "Los datos selecionados o la contraseña que haz ingresado no son los correctos, por favor verifica que sean correctos e intenta nuevamente.",
                    duration: 6000,
                    
                });
            }
        } else {
            //If the user dont select any branch we throw an error
            toast.error("Seleccione una sucursal");
        }

    }

    //Hook to get data when the page is loaded
    useEffect(() => {
        async function fetchData() {
            //We get the business code from the url params
            if (business_code !== undefined && new URL(window.location.href).hostname === process.env.REACT_APP_DASHBOARD_URL) {
                setBusinessCode(business_code);
                try {
                    //We get the business by code and wait for /auth/token to resolve so the
                    //public-token cookie for THIS business is set before requesting its users
                    let token = await getInitialData(business_code);
                    await getUsers(token);
                } catch (err) {
                    console.log(err);
                }
            } else {
                console.log("domain validation", new URL(window.location.href).hostname);
                //We validate the domain and get the business code
                let response = await ValidDomain();
                if (response !== undefined) {
                    setBusinessCode(response);
                    try {
                        //We get the business by code and wait for /auth/token to resolve so the
                        //public-token cookie for THIS business is set before requesting its users
                        let token = await getInitialData(response);
                        await getUsers(token);
                    } catch (err) {
                        console.log(err);
                    }
                } else {
                    console.log("No se pudo obtener el dominio válido");
                    navigate(`/error`)
                }
            }
        }
        fetchData();
    }, []);

    //Function to list the users of branchoffice
    const listUsers = () => {
        let users_list;
        if (users !== undefined) {
            users_list = users.map((data) => (
                <React.Fragment key={data.user_id}>
                    <input type="radio" className="spl-user-radio" name="email" id={data.user_id} value={data.email} />
                    <label className="spl-user" htmlFor={data.user_id}>
                        <span className="spl-ava">{getInitials(data.user_name)}</span>
                        <span className="spl-u-name">{data.user_name}</span>
                        <span className="spl-u-check"><IconCheck /></span>
                    </label>
                </React.Fragment>
            ))
        } else {
            users_list = ''
        }

        //We check the users list
        return (<>{users_list} </>)
    }

    const [showPassword, setShowPassword] = useState('')
    const toogglePasword = () => {
        setShowPassword(!showPassword);
    }


    useEffect(() => {

        let urlNow = window.location.href + ""
        let arrayParams = urlNow.split('/');
        console.log(arrayParams[3] + " " + arrayParams[4]);

        if (arrayParams[3] == "machines" && arrayParams[4] == "login") {
            console.log("entre");

            if (localStorage.getItem("x-access-token") == "" || localStorage.getItem("x-access-token") == undefined || localStorage.getItem("x-access-machine-token") == "" || localStorage.getItem("x-access-machine-token") == undefined || localStorage.getItem("branchoffice") == "" || localStorage.getItem("branchoffice") == undefined || localStorage.getItem("machine") == "" || localStorage.getItem("machine") == undefined || localStorage.getItem("user") == "" || localStorage.getItem("user") == undefined) {

            } else {

                let branchoffice = JSON.parse(localStorage.getItem('branchoffice'));
                let machine = JSON.parse(localStorage.getItem('machine'));
                let business = JSON.parse(localStorage.getItem("business"))

                //console.log(`/kiosk/${business.code}/${branchoffice.code}`);
                navigate(`/payments/${business.code}/${branchoffice.code}`)
            }
        }

    }, []);

    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

    // We use an effect to update the current year every minute to ensure it stays current
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentYear(new Date().getFullYear());
        }, 60000); //Update every minute to ensure the year is current
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="spl-root">
            <div className="spl-mesh" />
            <div className="spl-grain" />
            <div className="spl-grain spl-fine" />

            {/* nav */}
            <header className="spl-nav">
                <span className="spl-logo">
                    <img className="spl-logo-img" src={logo_sp} alt="Smart Pay" />
                    Smart Pay
                </span>
                <nav className="spl-links">
                    {/* <a href="#soporte">Soporte</a> */}
                    <a href="#estado">Empresa</a>

                    <span className="spl-b-id">
                        <IconStore />
                        <span className="spl-b-name">{businessData.name}</span>
                    </span>
                </nav>
            </header>

            {/* stage */}
            <main className="spl-stage">
                {/* izquierda */}
                <section className="spl-intro">
                    <span className="spl-eyebrow">Smart Pay · Gestión de negocio</span>
                    <h1>
                        Todo tu negocio,
                        <br />
                        bajo <em>control.</em>
                    </h1>
                    <p>
                        Ventas, inventario y sucursales en una sola vista. Toma mejores
                        decisiones y gestiona toda tu operación desde un solo lugar.
                    </p>
                    <div className="spl-foot">
                        <span className="spl-badge"><IconDashboard /></span>
                        <span className="spl-t">
                            <b>Una vista de todo tu negocio</b>
                            <span>Conectado a Smart Retail Group</span>
                        </span>
                    </div>
                </section>

                {/* derecha */}
                <section className="spl-cluster">
                    <div className="spl-card">
                        <img className="spl-brand-mark" src={logo_sp} alt="Smart Pay" />
                        <h2>Iniciar Sesión</h2>

                        {/* <div className="spl-branch-wrap">
                            <div className="spl-branch">
                                <span className="spl-b-id">
                                    <IconStore />
                                    <span className="spl-b-name">{businessData.name}</span>
                                </span>
                            </div>
                        </div> */}

                        <form className="spl-form" onSubmit={submit} noValidate>
                            <div className="spl-label"><span>Usuarios</span></div>
                            <div className="spl-users" role="radiogroup" aria-label="Usuarios">
                                {listUsers()}
                            </div>

                            <div className="spl-label"><span>Contraseña</span></div>
                            <div className="spl-field">
                                <IconLock className="spl-lk" />
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    className="spl-pw-input"
                                    id="password"
                                    name='pass'
                                    placeholder="Ingresar contraseña"
                                    required
                                    spellCheck="false"
                                />
                                <button
                                    type="button"
                                    className="spl-toggle"
                                    aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                                    onClick={toogglePasword}
                                >
                                    {showPassword ? <IconEyeOff /> : <IconEye />}
                                </button>
                            </div>

                            <button className="spl-submit" type="submit">
                                <span className="spl-lbl">Ingresar</span>
                                <IconArrow />
                            </button>
                        </form>

                        <div className="spl-card-foot">
                            <span>© {currentYear} Smart Pay</span>
                            <span className="spl-pw">
                                <IconBolt />
                                Powered by Smart Retail Group
                            </span>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    )
}

export default Login
